module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-components/attributes/attributes.component.css
// module id = ./src/app/product-components/attributes/attributes.component.css
// module chunks = main